import { forwardRef } from 'react';
import { LegendItem, LegendLabel, LegendOrdinal, LegendShape } from '@visx/legend';
import { scaleOrdinal } from '@visx/scale';

import { PiePartitionConfig } from '@blockworks/platform/api/research/studio';
import { FlexBox, Text } from '@blockworks/ui';
import { Bit } from '@blockworks/ui/factory';

import {
    containerProps,
    LEGEND_HTML_ID,
    LegendOrientation,
    LegendPosition,
    positonProps,
    wrapperProps,
} from '../../../models';

type PieLegendProps = {
    partitions: PiePartitionConfig[];
    position?: LegendPosition;
    orientation: LegendOrientation;
};

const PieLegend = forwardRef<HTMLDivElement, PieLegendProps>(function PieLegend(
    { partitions, orientation, position },
    ref,
) {
    const colorScale = scaleOrdinal({
        domain: partitions.map(d => d.label),
        range: partitions.map(d => d.color),
    });

    if (!position || position === 'none') return null;

    return (
        <Bit.div {...wrapperProps[orientation]} {...positonProps[position]} ref={ref} id={LEGEND_HTML_ID}>
            <LegendOrdinal scale={colorScale} labelFormat={label => `${label}`}>
                {labels => (
                    <FlexBox {...containerProps[orientation]}>
                        {labels.map((label, i) => (
                            <LegendItem key={`legend-quantile-${label.index}`} className="gap-.25 flex ">
                                <LegendShape
                                    shape="circle"
                                    itemIndex={i}
                                    label={label}
                                    height={8}
                                    width={8}
                                    margin={6}
                                    item={label.text}
                                    fill={() => label.value}
                                />
                                <LegendLabel
                                    label={
                                        <Text className={`color-${label.value}`} size="xxs" wordBreak="all" lines={1}>
                                            {label.text}
                                        </Text>
                                    }
                                    align="left"
                                />
                            </LegendItem>
                        ))}
                    </FlexBox>
                )}
            </LegendOrdinal>
        </Bit.div>
    );
});

export { PieLegend };
